import { useLocation, useNavigate } from 'react-router-dom';
import { usePaywall } from '../context/PaywallContext';

// "← Back" on the Terms and Privacy pages, shown only when they were opened from the paywall.
//
// The native app has no browser back button, so following a paywall legal link (required by
// Guideline 3.1.2(c)) stranded the user on the legal page: getting back to the purchase meant
// Account → Pricing → Upgrade again. App Review exercises exactly that path. Returning reopens
// the paywall too, so the user lands where they tapped rather than on the page behind it.
//
// Scoped to the paywall deliberately: arriving from Account is not a dead end, since the
// bottom tab bar still leads back.
export default function PaywallReturnLink() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { openPaywall } = usePaywall();

  if (!state?.fromPaywall) return null;

  const goBack = () => {
    navigate(-1);
    openPaywall();
  };

  return (
    <button type="button" onClick={goBack} className="ticker-back-link" style={{ marginBottom: '1rem' }}>
      ← Back
    </button>
  );
}
